import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const callout = style(
  {
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    borderRadius: themeVars.radius['10'],
  },
  'sheet-callout',
);
